import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TIMER } from '../../brands/default/content/components/checkout';
import { RESERVATION_TIMER_ENABLED } from '../../brands/default/features';
import { getSecsLeft, secondsToMinutesAndSeconds } from '../../helpers/timer';
import ThemeContext from '../../providers/ThemeProvider';
import { refreshCheckoutData } from '../../redux/actions/checkout';
import { CHECKOUT_STATUS } from '../../redux/reducers/checkout';

export default function Timer({ banner, countdown, status, token }) {
  const theme = useContext(ThemeContext);
  const [secondsLeft, setSecondsLeft] = useState(null);
  const [ssrTry, setSsrTry] = useState(true);

  /* countdown comes from the redux store, this value is set on the SSR on the build step, meaning the value on first load will ALWAYS be outdated,
 so we use ssrTry because we assume the first time the timer reaches 0 is due to the fact that the SSR value of countdown is ALWAYS in the past
 and this triggers a second unwanted and unneeded call to checkout api, after the first countdown refresh the flow keeps going as intended */
  const dispatch = useDispatch();
  useEffect(() => {
    if (countdown) {
      const interval = setInterval(() => {
        const remainingTime = getSecsLeft(countdown);
        setSecondsLeft(remainingTime);
      });

      return () => {
        clearInterval(interval);
      };
    }

    return null;
  }, [countdown]);

  useEffect(() => {
    if (secondsLeft === 0 && status === CHECKOUT_STATUS.READY) {
      dispatch(refreshCheckoutData(token, ssrTry));
      setSsrTry(false);
    }
  }, [secondsLeft]);

  if (!RESERVATION_TIMER_ENABLED) {
    return (
      <>
        <div />
      </>
    );
  }

  return (
    <>
      <div className={classNames('timer', { 'timer--banner': banner })}>
        <p className="timer__text">
          {(status === CHECKOUT_STATUS.READY ||
            status === CHECKOUT_STATUS.UPDATING) && (
            <>
              <span>{TIMER.timeRemaining}:</span>{' '}
              <span className="timer__time">
                {secondsToMinutesAndSeconds(secondsLeft)}
              </span>
            </>
          )}
          {status === CHECKOUT_STATUS.REFRESHING && (
            <span>{TIMER.refreshing}</span>
          )}
          {status === CHECKOUT_STATUS.REFRESHED && (
            <span>{TIMER.pricesConfirmed}</span>
          )}
        </p>
      </div>
      <style jsx>{`
        .timer {
          width: 170px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 10px 0;
          border-right: 1px solid #cccccc;
        }
        .timer__text {
          display: contents;
          font-size: 12px;
          font-weight: bold;
          margin-bottom: 0;
        }
        .timer__time {
          color: ${theme.colors.primary};
        }
        .timer--banner {
          display: none;
          width: 100%;
          border-right: none;
          border-top: 1px solid #6aac22;
          border-bottom: 1px solid #6aac22;
          background-color: #e2f0d9;
        }
        .timer--banner .timer__text {
          font-size: 14px;
        }
        :global(.timer--banner .timer__icon) {
          display: none;
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .timer {
            display: none;
          }
          .timer--banner {
            display: flex;
          }
        }
      `}</style>
    </>
  );
}

Timer.propTypes = {
  banner: PropTypes.bool,
  countdown: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  token: PropTypes.string,
};
